import React, { useState } from 'react';
import clsx from 'clsx';
import { KeenIcon } from '@/components';

const FormInput = ({
    type = 'text',
    label,
    labelRight,
    icon,
    name,
    value,
    onChange,
    onBlur,
    placeholder,
    error,
    touched,
    required = false,
    disabled = false,
    className,
    ...props
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePassword = (event) => {
        event.preventDefault();
        setShowPassword(!showPassword);
    };

    const isPassword = type === 'password';

    return (
        <div className="flex flex-col gap-1 w-full">
            {(label || labelRight) && (
                <div className="flex items-center justify-between gap-1">
                    {label && (
                        <label className="form-label text-gray-900">
                            {label}
                            {required && <span className="text-red-500 ml-1">*</span>}
                        </label>
                    )}
                    {labelRight}
                </div>
            )}
            <label className="input flex items-center w-full lg:px-3">
                {icon && (
                    <span className="flex items-center">{icon}</span>
                )}
                <input
                    type={isPassword ? (showPassword ? 'text' : 'password') : type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    disabled={disabled}
                    className={clsx('form-control bg-transparent flex-1 h-7 lg:h-8 px-2 lg:px-2 text-sm lg:text-base ', {
                        'is-invalid': touched && error
                    }, {
                        'is-valid': touched && !error
                    }, className)}
                    {...props}
                />
                {isPassword && (
                    <button className="btn btn-icon" onClick={togglePassword}>
                        <KeenIcon 
                            icon="eye" 
                            className={clsx('text-gray-500', {
                                hidden: showPassword
                            })} 
                        />
                        <KeenIcon 
                            icon="eye-slash" 
                            className={clsx('text-gray-500', {
                                hidden: !showPassword
                            })} 
                        />
                    </button>
                )}
            </label>
            {touched && error && (
                <span role="alert" className="text-danger text-xs mt-1">
                    {error}
                </span>
            )}
        </div>
    );
};

export default FormInput; 